<template>
  <div class="c3-chart"></div>
</template>
<script>
// eslint-disable-next-line import/no-extraneous-dependencies, no-unused-vars
import d3 from 'd3';
import c3 from 'c3';

export default {
  name: 'C3Chart',
  data() {
    return {
      $chart: null
    };
  },
  methods: {
    destroy() {
      if (this.$chart) {
        this.$chart = this.$chart.destroy();
      }
    },
    load(data) {
      if (this.$chart) {
        this.$chart.load(data);
      }
    },
    init(options) {
      let opt = options;
      if (!opt) throw new Error('You must load options when initiating!');
      if (this.options) {
        opt = this.options;
      }

      opt.bindto = this.$el;
      this.$chart = c3.generate(options);
    },
    unload(params) {
      if (this.$chart) {
        this.$chart.unload(params);
      }
    },
    clearRegions(params) {
      if (
        this.$chart 
        && this.$chart.regions 
        && this.$chart.regions.length > 0
      ) {
        if (params) {
          this.$chart.regions.remove(params);
        } else {
          this.$chart.regions([]);
        }
      }
    },
    addRegions(params) {
      if (this.$chart) {
        this.$chart.regions.add(params);
      }
    }
  },
  beforeDestroy() {
    this.destroy();
  }
};
</script>
<style lang="scss" scoped>
@import "../../../node_modules/c3/c3.min.css";
</style>
